import React from 'react';
import { useRecordContext } from 'react-admin';

const Cms1500JobTitle = () => {
    const record = useRecordContext();
    
    if (!record) return null;
    
    return (
        <span>
            CMS-1500 Job #{record.id} - {record.status}
        </span>
    );
};

export default Cms1500JobTitle;
